/**
 * Concord CRM - https://www.concordcrm.com
 *
 * @version   1.6.0
 *
 * @link      Releases - https://www.concordcrm.com/releases
 * @link      Terms Of Service - https://www.concordcrm.com/terms
 *
 * @copyright Copyright (c) 2022-2025 KONKORD DIGITAL
 */
let idCount = 0

/**
 * Simple unique ID implementation.
 * @return {number}
 */
function uniqueId() {
  return ++idCount
}

export default uniqueId
